import { Theme, Typography, withStyles, WithStyles } from '@material-ui/core';
import Paper from '@material-ui/core/Paper';
import { createStyles } from '@material-ui/core/styles';
import CheckCircleOutlineIcon from '@material-ui/icons/CheckCircleOutline';
import ErrorOutlineIcon from '@material-ui/icons/ErrorOutline';
import WarningIcon from '@material-ui/icons/Warning';
import React from 'react';
import { ErrorBoundary } from 'react-error-boundary';
// import JwPlayer from '../PlayoutPod/JwPlayer';
import VideoJsPlayer from '../PlayoutPod/VideoJsPlayer';
import WebRTCPlayer from '../PlayoutPod/WebRTCPlayer';
import { IPlayer } from './types';

const styles = (theme: Theme) =>
  createStyles({
    root: {},
    heading: {
      fontSize: 16,
      fontWeight: 500,
      marginBottom: 4
    },
    normalText: {
      fontSize: 12,
      fontWeight: 'normal',
      marginBottom: 4
    },
    healthyContainer: {
      fontSize: 14,
      fontWeight: 'normal',
      display: 'flex',
      alignItems: 'center',
      width: '160px'
    },
    imageMargin: {
      marginRight: 10
    },
    iconMargin: {
      marginLeft: 4
    },
    detailsContainer: {
      display: 'flex',
      justifyContent: 'space-between',
      width: '100%',
      alignItems: 'center'
    },
    healthText: {
      fontWeight: 500,
      marginLeft: 4,
      fontSize: '1rem'
    }
  });

const CustomPaper = withStyles((theme: Theme) => ({
  root: {
    background: `${theme.palette.type === 'dark' ? '#333333' : '#f0f0f0'}`,
    display: 'flex',
    alignItems: 'center',
    marginBottom: 24,
    borderRadius: 2,
    padding: `10px 11px`,
    paddingRight: 24,
    '&.AS_OK': {
      border: `2px solid #7dd321`
    },
    '&.AS_ERROR': {
      border: `2px solid #ff6e6b`
    },
    '&.active': {
      borderWidth: '4px'
    },
    '&.AS_WARNING': {
      border: `2px solid #f7ae64`
    }
  }
}))(Paper);

const SourceInputComponent: React.FC<
  {
    data: IPlayer;
  } & WithStyles
> = ({ data, classes }) => {
  return (
    <CustomPaper className={`${data.health} ${data.status}`} elevation={0}>
      <div
        style={{
          width: '60%',
          height: '75%',
          marginRight: '5%'
        }}
      >
        <ErrorBoundary
          fallback={
            <img
              alt="Video Error"
              src="https://via.placeholder.com/500x330/000000/FFFFFF/?text=Video%20Error"
            />
          }
        >
          {data.url ? (
            data.url.indexOf('janus') !== -1 ? (
              <WebRTCPlayer id={data.name} url={data.url} />
            ) : (
              <VideoJsPlayer src={data.url} />
            )
          ) : (
            <img
              alt="Unavailable"
              src="https://via.placeholder.com/160x100/000000/FFFFFF/?text=Unavailable"
            />
          )}
        </ErrorBoundary>
      </div>
      <div className={classes.detailsContainer}>
        <div>
          <Typography className={classes.heading} variant={'h5'}>
            {data.name}
          </Typography>
          <Typography className={classes.normalText} variant={'h5'}>
            {'Account : ' + data.account}
          </Typography>
          <Typography className={classes.normalText} variant={'h5'}>
            {'Channel : ' + data.channel}
          </Typography>
          <Typography className={classes.normalText} variant={'h5'}>
            {' Player : ' + data.player}
          </Typography>
        </div>
        <div>
          <Typography className={classes.healthyContainer} variant={'h3'}>
            {data.status === 'AS_OK' && (
              <CheckCircleOutlineIcon
                style={{ color: '#7dd321' }}
                className={classes.iconMargin}
              />
            )}
            {data.status === 'AS_ERROR' && (
              <ErrorOutlineIcon
                style={{ color: '#ff6e6b' }}
                className={classes.iconMargin}
              />
            )}
            {data.status === 'AS_WARNING' && (
              <WarningIcon
                style={{ color: '#f7ae64' }}
                className={classes.iconMargin}
              />
            )}
            <span className={classes.healthText}>
              {data.status === 'AS_OK'
                ? 'HEALTHY'
                : data.status === 'AS_ERROR'
                ? 'UNHEALTHY'
                : 'WARNING'}
            </span>
          </Typography>
        </div>
      </div>
    </CustomPaper>
  );
};

export default withStyles(styles)(SourceInputComponent);
